












import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const userModule = namespace('user');

@Component
export default class AppointmentOutcomeTypeSelect extends Vue {
    @typesModule.Getter('activeAppointmentOutcomeTypes') private appointmentOutcomeTypes!: Array<AppointmentOutcomeType>;
    @userModule.Getter('isInternalKeyStakeholder') public isInternalKeyStakeholder!: boolean;

    @Prop({ required: true }) private appointmentOutcome!: AppointmentOutcome;
    @Prop({ required: false, default: false }) private isEdit!: boolean;

    private get canEditOutcomeType(): boolean {
        return !this.isEdit || this.isInternalKeyStakeholder;
    }

    private get appointmentOutcomeTypeDescription(): string {
        if (this.appointmentOutcome.outcomeTypeId == null) {
            return '';
        }

        const appointmentOutcomeType = this.appointmentOutcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return appointmentOutcomeType == null ? '' : appointmentOutcomeType.value;
    }
}
